module.exports = __webpack_public_path__ + "static/media/img-tourvirtual.31379231.jpg";